import React from 'react';
import { styled } from '@mui/material/styles';
import { ListItemButton, ListItemText } from '@mui/material';
const PREFIX = 'ViewBillCheckoutNoteItem';

const classes = {
    root: `${PREFIX}root`
};

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
    [`&.${classes.root}`]: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        '&:last-child': {
            borderBottom: 'none'
        }
    }
}));

interface ViewBillCheckoutNoteItemProps {
    title: string;
    onClick: (index: number) => void;
    value?: string;
    index: number;
}

export const ViewBillCheckoutNoteItem: React.FC<React.PropsWithChildren<ViewBillCheckoutNoteItemProps>> = ({
    title,
    onClick,
    value,
    index
}) => {
    const handleClick = React.useCallback(() => {
        onClick(index);
    }, [index, onClick]);
    return (
        <StyledListItemButton onClick={handleClick} className={classes.root} disableGutters>
            <ListItemText primary={title} secondary={value} />
        </StyledListItemButton>
    );
};
